// extracted by mini-css-extract-plugin
module.exports = {"container":"carousel_container__23rf-","items":"carousel_items__c6mJd"};